import { Avatar, Stack, Typography } from "@mui/material"
import moment from "moment"
import { styles } from "./styles/NotifcationItem.styles"
import { FaComments, FaFileImage, FaFileAudio, FaBullhorn } from "react-icons/fa"

export const NOTIFICATION_ACTION_TYPES = {
  1: "See my sticker",
  2: "View my reward",
  3: "Check my progress",
}

export default function NotificationItem({
  notificationId,
  title,
  content,
  date,
  avatar,
  notificationTypeId,
  actionButton,
  seen,
  argument1,
  groupId,
  onNotificationOpened,
  // teacher messages additional props
  referenceId,
  groupName,
  hasUnreadMessages = false,
  imagePreview = null,
  audioPreview = null,
  messageTypeId,
}) {
  return (
    <Stack
      flexDirection={"row"}
      sx={[styles.notificationItem, hasUnreadMessages && styles.unreadNotification]}
      onClick={onNotificationOpened}
    >
      <Avatar src={avatar} sx={styles.avatar} />
      <Stack sx={styles.notificationItemContent}>
        <Typography
          variant="span"
          className="notification-item-title"
          sx={styles.notificationTitle}
        >
          {title}
          {groupName && (
            <Typography variant="span" sx={styles.notificationItemGroup}>
              {
                messageTypeId === 1 ?
                <FaComments style={styles.notificationGroupIcon} /> :
                <FaBullhorn style={styles.notificationGroupIcon} />
              }
              {groupName}
            </Typography>
          )}
        </Typography>
        <Typography
          variant="span"
          fontSize={14}
          sx={styles.notificationItemText}
        >
          {content}
          {imagePreview !== null && imagePreview !== "" && <FaFileImage />}
          {audioPreview !== null && audioPreview !== "" && <FaFileAudio />}
        </Typography>
        <Typography
          variant="span"
          className="notification-item-date"
          sx={styles.notificationItemAction}
        >
          {actionButton}
        </Typography>
        <Typography
          variant="span"
          className="notification-item-date"
          sx={styles.notificationItemDate}
        >
          {`${moment(date).format("MMM DD, YYYY")}${referenceId > 0 ? ` - #${referenceId}` : ""
            }`}
        </Typography>
      </Stack>
    </Stack>
  )
}
